import { render, staticRenderFns } from "./RecordsTable.vue?vue&type=template&id=187b6433&scoped=true"
import script from "./RecordsTable.ts?vue&type=script&lang=ts&external"
export * from "./RecordsTable.ts?vue&type=script&lang=ts&external"
import style0 from "./RecordsTable.scss?vue&type=style&index=0&id=187b6433&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187b6433",
  null
  
)

export default component.exports